import { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import IStepperConfig from '../../types/StepperConfig.types';

const customStyles = () => ({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    backgroundColor: '#2B83B5',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundColor: '#2B83B5'
  }
});

interface FormStepProps {
  active: boolean;
  completed: boolean;
  icon: number;
  classes: {
    root: any;
    active: any;
    completed: any;
  };
  step: string;
  stepperConfig: IStepperConfig;
}

export class FormStep extends Component<FormStepProps, {}> {
  getIcon: Function = (step: string, stepperConfig: IStepperConfig) => {
    switch (step) {
      case stepperConfig.EmailVerification:
        return <i className="material-icons">email</i>;
      case stepperConfig.RequestAccess:
        return <i className="material-icons">lock</i>;
      case stepperConfig.UserInfo:
        return <i className="material-icons">person</i>;
      case stepperConfig.SelectCompany:
        return <i className="material-icons">business</i>;
      case stepperConfig.BusinessInfo:
        return <i className="material-icons">business_center</i>;
      case stepperConfig.Diversity:
        return <i className="material-icons">groups</i>;
      case stepperConfig.Products:
        return <i className="material-icons">miscellaneous_services</i>;
      case stepperConfig.Login:
        return <i className="material-icons">check_circle</i>;
      default:
        return '';
    }
  };

  render() {
    const { active, completed, classes, step, stepperConfig } = this.props;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed
        })}
      >
        {this.getIcon(step, stepperConfig)}
      </div>
    );
  }
}

export default withStyles(customStyles)(FormStep);
